import differenceInMinutes from 'owa-datetime/lib/owaDate/differenceInMinutes';
import quickComposeStrings from 'owa-strings/owa-calendar-strings';
import { OwaDate } from 'owa-datetime';
import { format } from 'owa-strings';

/**
 * Formats the end time reflecting to also include the duration of the event
 * @param endTime
 * @param startTime
 */
export default function formatEndTime(endTime: OwaDate, startTime: OwaDate) {
    const diff = differenceInMinutes(endTime, startTime) / 60;
    const diffInHours = Number(diff.toFixed(2));

    const endTimeWithDuration: string =
        diffInHours <= 1
            ? format(quickComposeStrings.durationHour, diffInHours)
            : format(quickComposeStrings.durationFirstPluralHours, diffInHours);

    return endTimeWithDuration;
}
